import { RootState } from 'store';

export const userData = (state: RootState) => state.userData;
